import React, { useState, useEffect } from "react";
import TabList from "../../Components/TabList";
import { Grid, Box, Container, Typography } from "@mui/material";

//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from "../../Components/Footer";

const TermsConditions = () => {
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  return (
    <>
      <IndexHeader />
      <Typography style={{display: 'flex', justifyContent: 'center', marginTop:'70px'}} variant="h4" component="h2">
        Terms and Conditions
      </Typography>

      <Grid container>
        <Container maxWidth="lg" className="header-container-1">
          <Grid className="privacy-content" item xs={12} style={{ marginTop: "100px", marginBottom:'10px' }}>
           <p>
              PLEASE READ THE FOLLOWING TERMS OF SERVICE BEFORE USING OUR MOBILE APPLICATION MoneyTrek 
              (THE 'APP') OR THE WEBSITE https://jsonworld.com/moneytrek (THE WEBSITE). BY UTILIZING OUR APP, 
              OR ACCESSING ANY PAGE ON OUR SITE, YOU AGREE TO BE BOUND BY THE CURRENT VERSION OF THESE TERMS OF 
              SERVICE AND PRIVACY POLICY.
              </p>
              <p>
              1. Use of the App: You may use our Expense Tracker App for your personal use only. You may not use 
              our app for any commercial purpose or to provide services to any third party.
              </p>
              <p>
              2. Accuracy of Information: You are responsible for the accuracy of all information you enter into 
              the app. We are not responsible for any errors or omissions in the information you provide.
              </p>
            <p>
              3. Security: We take the security of your information very seriously. We use industry-standard 
              security measures to protect your data. However, we cannot guarantee that our app will be free 
              from unauthorized access or use.
            </p>
             <p>
              4. Privacy: We respect your privacy and will not share your information with any third party 
              without your consent. Please refer to our privacy policy for more information.
            </p>
           
            <p>
              5. Prohibited Activities: You may not use our app to engage in any illegal or unauthorized activities, including 
              but not limited to hacking, spamming, or distributing malware.
            </p>
           
            <p>
              6. Termination: We may terminate your use of our app at any time if you violate any of these terms and conditions.
            </p>
            <p>
            7. Disclaimer of Warranties: Our app is provided "as is" without any warranties or representations, express or implied. 
            We do not warrant that our app will be error-free or uninterrupted.
            </p>
            <p>
            8. Limitation of Liability: We will not be liable for any damages of any kind arising from your use of our app, including but 
            not limited to direct, indirect, incidental, punitive, and consequential damages.
            </p>
            <p>
            9. Changes to Terms and Conditions: We may update these terms and conditions from time to time. By 
            continuing to use our app, you agree to be bound by the updated terms and conditions.
            </p>
          </Grid>
          <Grid style={{marginBottom:'100px'}}>
          <Typography variant="h5" component="h2" style={{marginTop:'10px'}}>
            Cookie Use
          </Typography>

            Cookies and local storage provide you with a better, faster, and safer experience using this application. It is also used to operate our services, which include our websites, applications and email communications. Moneytrek uses these:
            <ul>
              <li>Keep you logged in.</li>
              <li>Deliver features and functionality of our services.</li>
              <li>Save your preferences.</li>
              <li>Personalize the content you see.</li>
              <li>Protect you against spam and abuse.</li>
              <li>Provide subscription features and distribute certain content.</li>
              <li>Understand how you interact with our services and where we can improve.</li>
              <li>Rate how our services perform and identify bugs and other quality issues.</li>
            </ul>
            <p>If you have any questions or concerns about these terms and conditions, please contact us at <strong>info@jsonworld.com</strong></p>
            <p>IF YOU DO NOT AGREE WITH THE ABOVE TERMS, PLEASE
              DO NOT USE THE APP.</p>
          </Grid>
        </Container>
      </Grid>

      <Footer />
    </>
  );
};

export default TermsConditions;
